import React from 'react';
import equal from 'deep-equal';
import {
  FlatButton,
  Dialog,
  CardHeader,
  CardText,
  CardActions,
  SelectField,
  MenuItem,
  CircularProgress,
  Table,
  TableHeader,
  TableRow,
  TableRowColumn,
  TableBody,
} from 'material-ui';

import plz from 'await-plz';

import { callApi } from '../client/apiToolbox';
import { API_BASE_URL } from '../App';
import { getTranslationByLocale } from '../utils/TranslationUtils';

const post = (url, body) =>
  callApi(
    url,
    'POST',
    {
      'Content-Type': 'application/json',
    },
    body
  );

class CloneButton extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedMarkets: [],
      clones: [],
      loading: true,
    };
  }

  shouldComponentUpdate = (nextProps, nextState) =>
    !equal(this.props, nextProps) || !equal(this.state, nextState);

  componentWillUpdate = async (nextProps, nextState) => {
    if (!this.state.open && nextState.open) {
      const url = API_BASE_URL || 'http://localhost:4042/api';
      const [resErr, markets] = await plz(
        fetch(`${url}/markets`, { credentials: 'include' })
      );
      if (resErr || !markets) return console.error('failed to fetch markets', resErr);
      return this.setState({ markets, loading: false });
    }
    return null;
  };

  save = async () => {
    const { record } = this.props;
    const { selectedMarkets } = this.state;

    this.setState({ cloning: true });
    const [, res] = await plz(
      post(`${API_BASE_URL}/utils/product/clone`, { markets: selectedMarkets, id: record.id })
    );

    this.setState({
      cloning: false,
      clones: res && res.json && res.success ? res.json.clones : [],
      selectedMarkets: [],
    });
  };

  toggle = () => this.setState({ open: !this.state.open });

  menuItems = (selectedMarkets, markets) =>
    markets &&
    markets.map((market) => (
      <MenuItem
        key={market.id}
        value={market.id}
        primaryText={getTranslationByLocale(market.title, this.props.locale)}
        checked={selectedMarkets.includes(market.id)}
        insetChildren
      />
    ));

  form = ({ selectedMarkets, markets, cloning }) => (
    <div>
      <CardHeader title="Clone product" style={{ paddingBottom: 0 }} />
      <CardText style={{ display: 'flex', flexDirection: 'column', paddingTop: 0 }}>
        <SelectField
          floatingLabelText="Markets to clone to"
          value={selectedMarkets}
          multiple
          onChange={(e, i, value) => this.setState({ selectedMarkets: value })}
        >
          {this.menuItems(selectedMarkets, markets)}
        </SelectField>
      </CardText>
      <CardActions style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
        <FlatButton label="Cancel" onClick={this.toggle} />
        <FlatButton
          onClick={() => {
            this.setState({ started: true });
            this.save();
          }}
          disabled={selectedMarkets.length === 0}
          primary
          icon={cloning ? <CircularProgress size={20} /> : null}
          label="Go!"
        />
      </CardActions>
    </div>
  );

  render() {
    const { open, loading, clones } = this.state;
    const Form = this.form;

    return (
      <FlatButton onClick={this.toggle} primary label="Clone">
        <Dialog open={open} onRequestClose={this.toggle}>
          {loading ? <CircularProgress /> : <Form {...this.state} />}
          {clones.length > 0 && (
            <Table>
              <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                <TableRow>
                  <TableRowColumn children="Name" />
                  <TableRowColumn children="Code" />
                  <TableRowColumn children="Market" />
                  <TableRowColumn />
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {clones.map((clone) => (
                  <TableRow>
                    <TableRowColumn children={clone.internalName} />
                    <TableRowColumn children={clone.code} />
                    <TableRowColumn children={clone.market} />
                    <TableRowColumn children={<a href={`#/products/${clone.code}`}>Edit</a>} />
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Dialog>
      </FlatButton>
    );
  }
}

export default CloneButton;
